import { useSelector } from "react-redux";
import { isFreemium } from "src/modules/auth/duck/selectors";
import NavigationButtons from "src/components/NavigationButtons";
import { usePurchaseContext } from "src/modules/purchase/PurchaseContext";
import { getPairedDevices } from "src/modules/device/duck/selectors/index";

import DeviceList from "./components/DeviceList";
import NoNearbyDevices from "./components/NoNearbyDevices";
import { Button } from "@chakra-ui/react";

export default function NearbyDevices({
  t,
  devices,
  initiatePairing,
  openManualPairing,
  mode,
  frame,
  onBack,
  onClose
}) {
  const purchase = usePurchaseContext();
  const isFreeVersion = useSelector(isFreemium);
  const pairedDevices = useSelector(getPairedDevices);
  const shouldOpenPurchaseFlow =
    isFreeVersion && Object.keys(pairedDevices).length >= 1;
  const hasDevices = devices.length > 0;

  const openManualPairingButton = (
    <Button
      variant="outlinedPrimary"
      onClick={openManualPairing}
      minWidth="120px"
    >
      {t("buttons.notFoundPairManually")}
    </Button>
  );

  return (
    <>
      <NavigationButtons mode={mode} onBack={onBack} onClose={onClose} />

      {hasDevices ? (
        <DeviceList
          frame={frame}
          devices={devices}
          onPair={initiatePairing}
          openManualPairingButton={openManualPairingButton}
          mode={mode}
          shouldOpenPurchaseFlow={shouldOpenPurchaseFlow}
          togglePurchaseFlow={() => purchase.open({ content: "unlimited" })}
        />
      ) : (
        <NoNearbyDevices openManualPairingButton={openManualPairingButton} />
      )}
    </>
  );
}
